<ng-container
  *ngIf="{
    securityPreferences: securityPreferences$?.data$ | async
  } as STATE"
>
  <main *ngIf="STATE.securityPreferences as securityPreferences">
    <p class="security-form__main-title">
      Modifier vos préférences de sécurité
    </p>
    <section class="security-form__content">
      <div>
        <p>Authentification à double facteur (2FA)</p>
        <article>
          <label class="toggle-switch">
            <input
              type="checkbox"
              aria-label="Double Factor Authentication"
              #doubleFactor
              [checked]="
                securityPreferences['security.authentication.double_factor']
              "
              (change)="updatePreference('doubleFactor', doubleFactor.checked)"
              class="toggle-switch__checkbox"
            />
            <div class="toggle-switch__swap"></div>
          </label>
        </article>
      </div>
      <div>
        <p class="description">
          Recevez un code OTP par mail pour vous connecter à votre compte
        </p>
      </div>
    </section>
    <section class="security-form__content">
      <div>
        <p>Notification après connexion (Watch Dogs)</p>
        <article>
          <label class="toggle-switch">
            <input
              type="checkbox"
              aria-label="Watch Dogs Notification"
              #watchDog
              [checked]="
                securityPreferences['security.authentication.watchdog']
              "
              (change)="updatePreference('watchdog', watchDog.checked)"
              class="toggle-switch__checkbox"
            />
            <div class="toggle-switch__swap"></div>
          </label>
        </article>
      </div>
      <div>
        <p class="description">
          Recevez une alerte par mail à chaque connexion avec vos identifiants.
        </p>
      </div>
    </section>
  </main>

  <loading-or-error
    *ngIf="!STATE.securityPreferences"
    (retry)="initSecurityPreferences()"
    [error$]="securityPreferences$?.errorLoading$"
  ></loading-or-error>
</ng-container>
